import { HourlyDataRequestGateway } from '@scenario/gateways/hourly-data-request.gateway';
import { HourlyDataRequest } from '@scenario/models/hourly-data-request.model';
import { formatPostHeaders } from '@configurations/api-configuration';
import { environment } from '../../../../../environments/environment';

export class ApiHourlyDataRequestGateway implements HourlyDataRequestGateway {
  private readonly specificHourlyDataRequestApi = `${environment.backend_url}/api/v1/user-specific-hourly-request`;
  private readonly customHourlyDataRequestApi = `${environment.backend_url}/api/v1/user-custom-hourly-request`;

  async request(hourlyDataRequest: HourlyDataRequest): Promise<void> {
    const isCustomRequest = hourlyDataRequest.yearsStart !== null && hourlyDataRequest.yearsEnd !== null;

    if (isCustomRequest) {
      const customBody = {
        email: hourlyDataRequest.email,
        zoneId: hourlyDataRequest.zoneId,
        sourceId: hourlyDataRequest.sourceId,
        basecaseId: hourlyDataRequest.basecaseId,
        comment: hourlyDataRequest.comment,
        reasons: hourlyDataRequest.reasons,
        weather_years: hourlyDataRequest.weatherYearIds,
        years_start: hourlyDataRequest.yearsStart,
        years_end: hourlyDataRequest.yearsEnd,
      };

      const response = await fetch(this.customHourlyDataRequestApi, await formatPostHeaders(customBody));
      if (!response.ok) {
        throw new Error('Error requesting hourly data: ' + response.statusText);
      }
    } else {
      const specificBody = {
        email: hourlyDataRequest.email,
        zoneId: hourlyDataRequest.zoneId,
        sourceId: hourlyDataRequest.sourceId,
        basecaseId: hourlyDataRequest.basecaseId,
        comment: hourlyDataRequest.comment,
        reasons: hourlyDataRequest.reasons,
      };

      const response = await fetch(this.specificHourlyDataRequestApi, await formatPostHeaders(specificBody));
      if (!response.ok) {
        throw new Error('Error requesting hourly data: ' + response.statusText);
      }
    }
  }
}
